(function () {
  const addToCartBtn = document.querySelector('button[name="add"]');
  if (!addToCartBtn) return;

  const productTitle = document.querySelector('.product__title h1, .product__title')?.innerText?.trim() || '';
  const productPrice = document.querySelector('.price-item--sale, .price-item--regular')?.innerText?.trim() || '';
  const isDisabled = addToCartBtn.disabled;

  const bar = document.createElement('div');
  bar.id = 'sticky-atc-bar';
  bar.style.cssText = `
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    display: none;
    align-items: center;
    gap: 10px;
    z-index: 9999;
    box-shadow: 0 -2px 8px rgba(0,0,0,0.1);
  `;

  bar.innerHTML = `
    <div style="flex: 1; min-width: 0; overflow: hidden;">
      <p style="margin: 0; font-size: 13px; font-weight: 600; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; color: #333;">${productTitle}</p>
      <p style="margin: 0; font-size: 13px; color: #cc0000; font-weight: 600;">${productPrice}</p>
    </div>
    ${!isDisabled ? `
    <button onclick="document.querySelector('button[name=add]').click();"
      style="background:#cc0000;color:white;padding:10px 16px;border-radius:6px;font-size:14px;font-weight:600;border:none;cursor:pointer;white-space:nowrap;">
      Add to Cart
    </button>` : ''}
    <a href="https://wa.me/96176773638?text=مرحبا،%20أريد%20الطلب%20عبر%20واتساب%3A%20${encodeURIComponent(productTitle)}"
       target="_blank"
       style="background:#25D366;color:white;padding:10px 16px;border-radius:6px;font-size:14px;font-weight:600;text-decoration:none;white-space:nowrap;">
      WhatsApp
    </a>
  `;

  document.body.appendChild(bar);

  function checkVisibility() {
    const rect = addToCartBtn.getBoundingClientRect();
    const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
    bar.style.display = isVisible ? 'none' : 'flex';
  }

  window.addEventListener('scroll', checkVisibility);
  window.addEventListener('resize', checkVisibility);
  checkVisibility();
})();